import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getLeaderboardData,
  getLeaderboardError,
  getLeaderboardStatus,
} from "../../../redux/slice/leaderboardSlice";
import { fetchTopics, getTopics } from "../../../redux/slice/topicSlice";
import AlertBox from "../../common/AlertBox";
import Loading from "../../common/Loading";
import NumberedPagination from "../../pagination/NumberedPagination";
import LeaderBoardItem from "./LeaderBoardItem";

const LeaderBoardList = () => {
  const dispatch = useDispatch();

  const data = useSelector(getLeaderboardData);
  const status = useSelector(getLeaderboardStatus);
  const error = useSelector(getLeaderboardError);
  const topics = useSelector(getTopics);

  const [topic, setTopic] = useState("");

  useEffect(() => {
    if (!topics) {
      dispatch(fetchTopics());
    }
  }, [dispatch, topics]);

  const filteredData = data?.filter((entry) =>
    topic ? entry.topicName === topic : entry
  );
  const len = filteredData?.length;

  const pageSize = 5;

  const [currentPage, setCurrentPage] = useState(1);

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return filteredData?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, filteredData]);

  return (
    <section>
      {status === "loading" ? <Loading /> : null}
      {status === "failed" ? <AlertBox type="failed" message={error} /> : null}
      <div className="flex flex-col gap-6">
        <div className="flex flex-row justify-between items-center">
          <div className="flex flex-col">
            <h2 className="text-[28px] font-semibold text-textPrimary leading-[40px]">
              Leaderboard
            </h2>
            <span className="text-textSecondary text-sm">
              Leaderboard of this week:
            </span>
          </div>
          <div className="">
            <select
              name="topic"
              id="topic"
              value={topic}
              onChange={(e) => setTopic(e.target.value)}
              className="h-[36px] font-medium border px-4 rounded-[8px] border-textSecondary focus:outline-none text-textSecondary w-full"
            >
              <option value="">All topics</option>
              {topics?.map((topicItem) => (
                <option key={topicItem._id} value={topicItem.topicName}>
                  {topicItem.topicName}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="w-full overflow-x-auto rounded-t-[10px]">
          <table className="w-full text-center">
            <thead className="text-textSecondary text-sm">
              <tr className="border-b p-2 tracking-wider">
                <th className="px-2 py-4 overflow-clip">Rank</th>
                <th className="px-2 py-4 overflow-clip">Name</th>
                <th className="px-2 py-4 overflow-clip">Topic</th>
                <th className="px-2 py-4 overflow-clip">Date</th>
                <th className="px-2 py-4 overflow-clip">Points</th>
                <th className="px-2 py-4 overflow-clip">Attempts</th>
              </tr>
            </thead>
            <tbody>
              {currentTableData?.length === 0 ? (
                <tr className="border-b">
                  <td colSpan="6" className="px-2 py-4  text-center">
                    No Leaderboard found
                  </td>
                </tr>
              ) : (
                currentTableData.map((entry, index) => (
                  <LeaderBoardItem
                    data={entry}
                    index={index + (currentPage - 1) * pageSize}
                    key={index}
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
        <NumberedPagination
          currentPage={currentPage}
          totalCount={len}
          pageSize={pageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </section>
  );
};

export default LeaderBoardList;
